export default "__VITE_ASSET__4Y7yNNeJ__"